import api from '../../api/index.js'
import Vue from "vue";


const state = {
    accessToken: {
        access_token: "",
        token_type: "",
        expires_in: "",
        no: "",
        memberID : "",
        issued : "",
        expires : "",
    },
    isLogin: false,
}

const getters = {
    currentToken: state => {
        var data = {
            access_token: state.accessToken.access_token,
            token_type: state.accessToken.token_type,
            expires_in: state.accessToken.expires_in,
            no : state.accessToken.no,
            memberID: state.memberID,
            issued: state.issued,
            expires: state.expires,
            isLogin: state.isLogin
        };
        var accessToken=JSON.parse(localStorage.getItem("accessToken"));
        //console.log(accessToken);
        if (accessToken != null&&accessToken.access_token!=null) {
            Object.assign(data, {
                access_token: accessToken.access_token,
                token_type: accessToken.token_type,
                expires_in: accessToken.expires_in,
                no : accessToken.no,
                memberID: accessToken.memberID,
                issued: accessToken.issued,
                expires: accessToken.expires,
                isLogin: true
            });
            Vue.set(state,"isLogin",true);
        }
        return data;
    }
}

const actions = {
    Login({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.post('/Account/Login',payload, res => {
                commit({
                    type: "setAccessToken",
                    res: res,
                })
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
    GetAccessToken ({commit}, payload) {   
        return new Promise((resolve, reject) => {
            api.get('/Token/GetPasswordToken',payload, res => {
                commit({
                    type: "setAccessToken",
                    res: res,
                })
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
    Register({commit}, payload) {        
        return new Promise((resolve, reject) => {
            api.post('/Register/RegisterMemberVue',payload, res => {
                commit({
                    type: "setAccessToken",
                    res: res,
                })
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
    Logout({commit}) {
        return new Promise((resolve) => {
            commit({
                type: "setLogout"
            })
            resolve();
        })
    },
    SendRegisterSmsCodeVue({commit},payload) {
        return new Promise((resolve, reject) => {
            api.post('/Shared/SendSmsVue',payload, res => {
                resolve(res)
            }, err => {
                reject(err)
            })
        })
    }
}

const mutations = {
    setAccessToken(state, payload) {
        if(payload.res.Code == "200"){
            if(payload.res.Result.error_description == "" || payload.res.Result.error_description == null) {
                var _data = {
                    access_token: payload.res.Result.access_token,
                    token_type: payload.res.Result.token_type,
                    expires_in:payload.res.Result.expires_in,
                    no : payload.res.Result.no,
                    memberID: payload.res.Result.memberID,
                    issued: payload.res.Result.issued,
                    expires: payload.res.Result.expires,
                    isLogin:true
                };
                localStorage.setItem("accessToken", JSON.stringify(_data));
                // var accessToken=JSON.parse(localStorage.getItem("accessToken"));
                localStorage.setItem("token", _data.access_token);
                Vue.set(state,"isLogin",true);
                //state.isLogin = true;
            }
        }
    },
    setLogout(state) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("token");
        Vue.set(state,"isLogin",false);
        //state.isLogin = false;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
